import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  propertyImagesLabels: [],
  addImagesLabelsData: [],
  allPropertyImagesLabels: []
};

export const PropertyImagesLabelsSlice = createSlice({
  name: "propertyImagesLabels",
  initialState,
  reducers: {
    getAllPropertyImagesLabelsAction: (state, action) => {
      
      state.allPropertyImagesLabels = action.payload;
    },
    getSinglePropertyImagesLabelsAction: (state, action) => {
      
      state.propertyImagesLabels = action.payload;
    },
    getAddImagesLabelsDataAction: (state, action) => {
      
      state.addImagesLabelsData = action.payload;
    },
  },
});

export default PropertyImagesLabelsSlice.reducer;

export const { getAllPropertyImagesLabelsAction, getSinglePropertyImagesLabelsAction, getAddImagesLabelsDataAction } = PropertyImagesLabelsSlice.actions;
